<ldw-split-view [useSplitMode]="useSplitMode" [hasDetail]="hasDetail">
  <div class="split-view-content-list">
    @if (hasHistoryData()) {
      <mat-toolbar>
        <button mat-button (click)="clearHistory()" ><mat-icon>delete</mat-icon>
      {{'HISTORY.CLEAR'|translate}}</button>
    </mat-toolbar>
  }
  <ldw-structure-list-view [data]="documents" (itemSelected)="itemSelected($event)" [showTreePath]="true" [showNoData]="showNoData"></ldw-structure-list-view>
</div>
@if (hasDetail) {
  <div class="split-view-content-detail">
    <ldw-detail-document-view [documentId]="detailDocumentId"
      (visibleChanged)="detailVisibleChanged($event)">
    </ldw-detail-document-view>
  </div>
}
</ldw-split-view>
